var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.3333 34H45.3333L39.6667 42.5H28.3333L22.6667 34H5.66667",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4415 14.479L5.6665 34.0007V51.0006C5.6665 52.5035 6.26353 53.9449 7.32623 55.0076C8.38894 56.0703 9.83028 56.6673 11.3332 56.6673H56.6665C58.1694 56.6673 59.6107 56.0703 60.6734 55.0076C61.7362 53.9449 62.3332 52.5035 62.3332 51.0006V34.0007L52.5582 14.479C52.089 13.5349 51.3658 12.7404 50.4699 12.1848C49.5739 11.6292 48.5407 11.3345 47.4865 11.334H20.5132C19.4589 11.3345 18.4258 11.6292 17.5298 12.1848C16.6338 12.7404 15.9106 13.5349 15.4415 14.479Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.ff351b2f834d91112857fa1bea5d3494.svg";
export { ForwardRef as ReactComponent };